



































































































































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import { vxm } from '@/store';
import { CreateProjectDto } from '@/@types/Project';

@Component({
  components: {
    OrganizationIcon,
    CommonModalHeader,
  },
})
export default class ProjectAddModal extends Vue {
  @Prop(Boolean) public isOpenAddProjectModal!: boolean;
  private isProjectIconFileUploaded: boolean = false;
  private projectIconFileName: string = '';
  private projectIconColor: string = 'light-blue lighten-3';
  private projectIconSize: number = 200;
  private projectName: string = '';
  private projectOverview: string = '';
  private projectIconURL: string = '';
  private modalHeaderTitle: string = 'プロジェクト追加';
  private modalMode: string = 'add';
  private modalHeaderWidthElementId: string = '#project-add-modal';
  private isOpenUpdateProjectIconModal: boolean = false;

  @Emit('closeAddProjectModal')
  private closeAddProjectModal(): boolean {
    return false;
  }

  private async addProject(): Promise<void> {
    const createProjectDto: CreateProjectDto = {
      projectName: this.projectName,
      organizationId: this.organizationId ? this.organizationId : 0,
      projectIconImage: null,
      projectHeaderImage: null,
      projectBackgroundImage: null,
      projectOutline: null,
      projectStartDate: null,
      projectWillFinishDate: null,
      customAttribute1Name: null,
      customAttribute1Style: null,
      customAttribute1DisplayStyle: null,
      customAttribute1DisplayFlag: false,
      customAttribute2Name: null,
      customAttribute2Style: null,
      customAttribute2DisplayStyle: null,
      customAttribute2DisplayFlag: false,
      customAttribute3Name: null,
      customAttribute3Style: null,
      customAttribute3DisplayStyle: null,
      customAttribute3DisplayFlag: false,
      customAttribute4Name: null,
      customAttribute4Style: null,
      customAttribute4DisplayStyle: null,
      customAttribute4DisplayFlag: false,
      customAttribute5Name: null,
      customAttribute5Style: null,
      customAttribute5DisplayStyle: null,
      customAttribute5DisplayFlag: false,
      customAttribute6Name: null,
      customAttribute6Style: null,
      customAttribute6DisplayStyle: null,
      customAttribute6DisplayFlag: false,
      customAttribute7Name: null,
      customAttribute7Style: null,
      customAttribute7DisplayStyle: null,
      customAttribute7DisplayFlag: false,
      customAttribute8Name: null,
      customAttribute8Style: null,
      customAttribute8DisplayStyle: null,
      customAttribute8DisplayFlag: false,
      customAttribute9Name: null,
      customAttribute9Style: null,
      customAttribute9DisplayStyle: null,
      customAttribute9DisplayFlag: false,
      customAttribute10Name: null,
      customAttribute10Style: null,
      customAttribute10DisplayStyle: null,
      customAttribute10DisplayFlag: false,
      customAttribute11Name: null,
      customAttribute11Style: null,
      customAttribute11DisplayStyle: null,
      customAttribute11DisplayFlag: false,
      customAttribute12Name: null,
      customAttribute12Style: null,
      customAttribute12DisplayStyle: null,
      customAttribute12DisplayFlag: false,
      customAttribute13Name: null,
      customAttribute13Style: null,
      customAttribute13DisplayStyle: null,
      customAttribute13DisplayFlag: false,
      customAttribute14Name: null,
      customAttribute14Style: null,
      customAttribute14DisplayStyle: null,
      customAttribute14DisplayFlag: false,
      customAttribute15Name: null,
      customAttribute15Style: null,
      customAttribute15DisplayStyle: null,
      customAttribute15DisplayFlag: false,
      customAttribute16Name: null,
      customAttribute16Style: null,
      customAttribute16DisplayStyle: null,
      customAttribute16DisplayFlag: false,
      customAttribute17Name: null,
      customAttribute17Style: null,
      customAttribute17DisplayStyle: null,
      customAttribute17DisplayFlag: false,
      customAttribute18Name: null,
      customAttribute18Style: null,
      customAttribute18DisplayStyle: null,
      customAttribute18DisplayFlag: false,
      customAttribute19Name: null,
      customAttribute19Style: null,
      customAttribute19DisplayStyle: null,
      customAttribute19DisplayFlag: false,
      customAttribute20Name: null,
      customAttribute20Style: null,
      customAttribute20DisplayStyle: null,
      customAttribute20DisplayFlag: false,
      customAttribute21Name: null,
      customAttribute21Style: null,
      customAttribute21DisplayStyle: null,
      customAttribute21DisplayFlag: false,
      customAttribute22Name: null,
      customAttribute22Style: null,
      customAttribute22DisplayStyle: null,
      customAttribute22DisplayFlag: false,
      customAttribute23Name: null,
      customAttribute23Style: null,
      customAttribute23DisplayStyle: null,
      customAttribute23DisplayFlag: false,
      customAttribute24Name: null,
      customAttribute24Style: null,
      customAttribute24DisplayStyle: null,
      customAttribute24DisplayFlag: false,
      customAttribute25Name: null,
      customAttribute25Style: null,
      customAttribute25DisplayStyle: null,
      customAttribute25DisplayFlag: false,
      customAttribute26Name: null,
      customAttribute26Style: null,
      customAttribute26DisplayStyle: null,
      customAttribute26DisplayFlag: false,
      customAttribute27Name: null,
      customAttribute27Style: null,
      customAttribute27DisplayStyle: null,
      customAttribute27DisplayFlag: false,
      customAttribute28Name: null,
      customAttribute28Style: null,
      customAttribute28DisplayStyle: null,
      customAttribute28DisplayFlag: false,
      customAttribute29Name: null,
      customAttribute29Style: null,
      customAttribute29DisplayStyle: null,
      customAttribute29DisplayFlag: false,
      customAttribute30Name: null,
      customAttribute30Style: null,
      customAttribute30DisplayStyle: null,
      customAttribute30DisplayFlag: false,
      openFlag: true,
    };
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
    const required = this.rules.required(this.projectName);
    if (required != true) {
      (this.$refs.projectNameField as HTMLElement).focus();
      return;
    }
    const createResult = await vxm.theoryApi.projectsStore.createProject(
      createProjectDto
    );
    if (createResult) {
      const projectId = createResult.results.projectId;
      await vxm.theoryApi.accountsStore.fetchAccountBasicParticipationProjects({
        accountId: this.accountId as number,
        organizationId: this.organizationId as number,
      });
      const projects = vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects;
      if (projects) {
        const project = projects.results.find((project) => {
          return project.projectId === projectId;
        });
        if (project) {
          vxm.theoryApi.authStore.fetchCurrentProjectId(projectId);
          vxm.theoryApi.authStore.fetchCurrentProjectName(project.projectName);
          await Promise.all([
            vxm.theoryApi.projectsStore.fetchProjectBasic(projectId),
            vxm.theoryApi.projectMembersStore.fetchProjectMembersById(projectId),
          ]);
        }
      }
    }

    this.closeAddProjectModal();
  }

  private openProjectIconExplorer(): void {
    const projectIconFile = this.$refs.projectIconFile as HTMLElement;
    projectIconFile.click();
  }

  private readProjectIconImage(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files!.length) {
      return;
    }
    this.projectIconURL = URL.createObjectURL(files![0]);
    this.isProjectIconFileUploaded = true;
    this.projectIconFileName = files!.item(0)!.name;
  }

  private deleteProjectIconFile(): void {
    this.isProjectIconFileUploaded = false;
    this.projectIconFileName = '';
  }

  private rules = {
    required: (value: string) => !!value || '必ず入力してください。',
  };

  private get organizationId() {
    return vxm.theoryApi.authStore.getCurrentOrganizationId;
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return null;
  }
}
